<template>
    <div>
         <div class="q-display-1 q-mb-md">
            <span class="q-headline text-weight-light">{{ $t('level_history') }}</span>
        </div>

        <q-table :data="history_level" :columns="columns" hide-bottom row-key="__index">
            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="__index" :props="props">
                    {{ props.row.__index }}
                </q-td>

                <q-td auto-width key="user_full_name" :props="props">
                    {{ props.row.user_full_name }}
                </q-td>

                <q-td auto-width key="level_from" :props="props">
                    {{ props.row.level_from }}
                </q-td>

                <q-td auto-width key="level_to" :props="props">
                    {{ props.row.level_to }}
                </q-td>

                <q-td auto-width key="points_from" :props="props">
                    {{ props.row.points_from }}
                </q-td>

                <q-td auto-width key="points_to" :props="props">
                    {{ props.row.points_to }}
                </q-td>

                <q-td auto-width key="created_date" :props="props">
                    {{ fDate(props.row.created_date) }}
                </q-td>
            </q-tr>
        </q-table>

        <div class="row gutter-sm justify-end q-my-sm" v-if="showButtonsEdit">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="positive" class="full-width" :label="$t('level_up')" icon="far fa-chevron-up" @click="levelUp()" :disable="!allowed_to_level_up"/>
            </div>
        </div>

        <q-table
            :data="level_up_history"
            :columns="columns_level_up_history"
            :title="$t('level_up_history')"
            row-key="date_acquired"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            binary-state-sort
            class="q-mt-md"
            hide-bottom
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td key="level" :props="props">
                    {{ props.row.level }}
                </q-td>

                <q-td key="date_acquired" :props="props">
                    {{ fDateTime(props.row.date_acquired) }}
                </q-td>

                <q-td key="date_leveled_up" :props="props">
                    {{ fDateTime(props.row.date_leveled_up) }}
                </q-td>

                <q-td key="responsible_user_full_name" :props="props">
                    {{ props.row.responsible_user_full_name }}
                </q-td>
            </q-tr>
        </q-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props:['id'],
    
    data() {
        return {
            allowed_to_level_up: false,
            columns: [{
                align: 'left',
                field: '__index',
                label: '#',
                name: '__index',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'user_full_name',
                label: 'responsible',
                name: 'user_full_name',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'level_from',
                label: 'level_from',
                name: 'level_from',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'level_to',
                label: 'level_to',
                name: 'level_to',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'points_from',
                label: 'points_from',
                name: 'points_from',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'points_to',
                label: 'points_to',
                name: 'points_to',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'created_date',
                label: 'created_date',
                name: 'created_date',
                required: true,
                sortable: false
            }],
            columns_level_up_history: [{
                align: 'left',
                field: 'level',
                label: 'level',
                name: 'level',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'date_acquired',
                label: 'date_of_acquisition',
                name: 'date_acquired',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'date_leveled_up',
                label: 'level_up_date',
                name: 'date_leveled_up',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'responsible_user_full_name',
                label: 'responsible_for_leveling_up',
                name: 'responsible_user_full_name',
                required: true,
                sortable: false
            }],
            dates_levels: [],
            history_level: [],
            id_rewards_level: '',
            level_up_history: [],
            user_id: null
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            reward_levels: 'registration_lists/reward_levels',
			user_module_items: 'common/user_module_items',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showButtonsEdit() {
            if (this.user_module_items) {
				let obj = this.user_module_items.find(
					(obj) => obj.slug == 'reward_audit_user_level' && obj.permission == true
				)
				if (obj) return true
			}
            return false
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/admin_rewards/users_reward_levels/${this.id_rewards_level}/`, this.getHeader)
            .then(response => {
                this.user_id = response.data.user_id
                this.allowed_to_level_up = response.data.allowed_to_level_up
                this.history_level = response.data.reward_level_responsibles
                this.level_up_history = response.data.date_leveled_up.map(e => ({
                    ...e,
                    responsible_user_full_name: e.responsible_user_full_name ? `${e.responsible_user_full_name} ${e.responsible_user_email ? `(${e.responsible_user_email})` : ''}` : ''
                }))
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        levelUp() {
            this.$q.loading.show()

            let data = {user_id: this.user_id}

            this.$axios.post(`/admin_rewards/users_reward_levels/${this.id}/level_up/`, data, this.getHeader)
            .then(response => {
                this.$q.notify({
                    message: this.$t('save_data_success'),
                    type: 'positive',
                    icon: 'fal fa-check',
                    position: 'bottom'
                })

                this.$router.push({ name: 'users_reward_levels' })
            })
            .catch(e => {
                console.log(e)
                
                this.$q.notify({
                    message: this.$t('save_data_error'),
                    type: 'negative',
                    icon: 'fal fa-ban',
                    position: 'bottom'
                })
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm'
                    break
                    default: format = 'MM-DD-YYYY HH:mm'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        fDateTime(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        }
    },

    created() {
        this.id_rewards_level = this.$route.params.id
        this.fetchData()
    }
}
</script>

<style>

</style>